import React from 'react';
import { COLORS } from './chartTheme';

// Inline mini line chart: fixed-aspect SVG, no axes, optional gradient fill.
// points: number[] (evenly spaced).
export default function Sparkline({
  points = [],
  width = 96,
  height = 28,
  color = COLORS.teal,
  fill = true,
  strokeWidth = 1.6,
}) {
  const id = React.useId();
  if (!points.length) return <svg width={width} height={height} aria-hidden="true" />;
  const max = Math.max(...points, 1);
  const min = Math.min(...points, 0);
  const span = max - min || 1;
  const pad = strokeWidth;
  const px = (i) => (points.length === 1 ? width / 2 : pad + (i / (points.length - 1)) * (width - pad * 2));
  const py = (v) => pad + (1 - (v - min) / span) * (height - pad * 2);
  const line = points.map((v, i) => `${i ? 'L' : 'M'}${px(i).toFixed(1)},${py(v).toFixed(1)}`).join(' ');
  const area = `${line} L${px(points.length - 1).toFixed(1)},${height} L${px(0).toFixed(1)},${height} Z`;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-hidden="true" className="ck-spark">
      {fill && (
        <>
          <defs>
            <linearGradient id={`sp${id}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity="0.28" />
              <stop offset="100%" stopColor={color} stopOpacity="0" />
            </linearGradient>
          </defs>
          <path d={area} fill={`url(#sp${id})`} />
        </>
      )}
      <path d={line} fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
